import s from './product.module.css';
import Breadcrumbs from "../../../assets/Components/breadcrumbs/breadcrumbs";
import React, {useState} from "react";
import {useSelector} from "react-redux";
import ProductMain from "./ProductContent/ProductMain";
import ProductTabDesription from "./ProductTab/ProductTabDesription";
import ProductTabCharacters from "./ProductTab/ProductTabCharacters";
import ProductTabReview from "./ProductTab/ProductTabReview";
import ProductTabDelivery from "./ProductTab/ProductTabDelivery";
import Categories from "../Categories";


const Product = ({refTab, ...props}) => {
    const productData = useSelector(state => state.setProduct);
    const [tabItem, setTabItem] = useState(1);
    let tabContent = null;


    const goToReviews = () => {
        setTabItem(3);
    }

    if (tabItem == 1) {
        tabContent = <ProductTabDesription/>
    } else if (tabItem == 2) {
        tabContent = <ProductTabCharacters/>
    } else if (tabItem == 3) {
        tabContent = <ProductTabReview/>
    } else if (tabItem == 4) {
        tabContent = <ProductTabDelivery/>
    }


    return (
        <div className={s.product}>
            <div className={`${s.productContent} content`}>
                <Breadcrumbs title={productData.categoryTitle} name={productData.name}/>
                <ProductMain togglePopUp={props.togglePopUp} scrollToMyRef={props.scrollToMyRef}
                             goToReviews={goToReviews} productData={productData}/>
                <div className={s.productTabs}>
                    <ul className={s.productTabsList}>
                        <li className={tabItem == 1 ? s.tabActive : null} onClick={() => setTabItem(1)}>ОПИСАНИЕ</li>
                        <li className={tabItem == 2 ? s.tabActive : null} onClick={() => setTabItem(2)}>ХАРАКТЕРИСТИКИ
                        </li>
                        <li className={tabItem == 3 ? s.tabActive : null} onClick={() => setTabItem(3)}>ОТЗЫВЫ</li>
                        <li className={tabItem == 4 ? s.tabActive : null} onClick={() => setTabItem(4)}>ОПЛАТА И
                            ДОСТАВКА
                        </li>
                    </ul>
                    <div ref={refTab} className={s.productTadInfo}>
                        {
                            tabContent
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Product;